/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-06 20:13:08
 * @Description: 新建/编辑页
 */
 'use strict';
 angular.module("editPicModule", ['editPicRouterModule']).
     controller('editPicCtrl', ['$scope', '$timeout', '$validation', '$stateParams', '$state', 'localStorageService', 'modalDialog', '$q', 'ueditorService', 'httpService', "$element", "$compile", "editPictureService", function ($scope, $timeout, $validation, $stateParams, $state, localStorageService, modalDialog, $q, ueditorService, httpService, $element, $compile, editPictureService) {
         initStatus();
         initData();
         /**
          * [save description] 保存
          * @return {[type]} [description]
          */
 
         $scope.save = function () {
             $scope.list.bPub = false;
             saveContent().then(function () {
                 return validator();
             }).then(function () {
                 return save();
             }).then(function (data) {
                 if (data.success) {
                     var newId = data.data.id;
                     $scope.list.id = newId;
                     // modalDialog.alertType("", "保存稿件成功", "success", false);
                     modalDialog.success("保存稿件成功", "success", false, function () { }, function () { }, '', 'left0');
                     reFreshListPage();
                     ueditorService.saveToLocal(newId, '3');
                     $state.go("editPic", { id: newId, type: 6 });
                 }
             });
         };
         /**
          * [submission description] 投稿
          * @return {[type]} [description]
          */
         $scope.submission = function () {
             $scope.list.bPub = false;
             saveContent().then(function () {
                 return validator();
             }).then(function () {
                 return save();
             }).then(function (data) {
                 if (data.success) {
                     var newId = data.data.id;
                     var vparams = {
                         ids: newId
                     };
                     $scope.loadingPromise = httpService.http('/mcnww/web/article/contribute.do', vparams, 'get').then(function (data) {
                         modalDialog.success('投稿成功', 'success', false, function () {
                             reFreshListPage();
                             ueditorService.saveToLocal(newId, '3');
                             window.close();
                         }, function () { }, 2000, 'left0');
                     });
                 }
             });
         };
         /**
          * [save description] 保存方法
          * @return {[type]} [description]
          */
         function save() {
             var deffer = $q.defer();
             $scope.list.articleWordsCount = $scope.list.DOCWORDSCOUNT;
             var picList = $scope.status.imageArrs.map(function (item) {
                return (
                  item.fileName +
                  ":" +
                  item.title +
                  ":" +
                  item.url +
                  ":" +
                  item.thumFileName +
                  ":" +
                  item.instruction
                );
              });
              picList = picList.join(",");
              $scope.list.pictureIds = picList;
             $scope.loadingPromise = httpService.http("/mcnww/web/article/addEdit.do", $scope.list, "post").then(function (data) {
                 deffer.resolve(data);
             });
             return deffer.promise;
         }
         /**
          * [validator description] 表单校验
          * @return {[type]} [description]
          */
         function validator() {
             var deffer = $q.defer();
             $validation.validate($scope.editPageForm).success(function () {
                 deffer.resolve();
             }).error(function (result) {
                 angular.invalidPosition($scope.editPageForm, $element);
             });
             return deffer.promise;
         }
         /**
          * [saveContent description] 保存正文
          * @return {[type]} [description]
          */
         function saveContent() {
             var deffer = $q.defer();
             ueditorService.saveContent($scope.list);
             if ($scope.list.articleHtmlCon === "") {
                 $timeout(function () {
                     //表单校验手动触发
                     $scope.editPageForm.content.$error.content = true;
                     $scope.editPageForm.content.$valid = false;
                     $scope.editPageForm.content.$invalid = true;
                     $scope.editPageForm.$error.content = [$scope.editPageForm.content];
                     $scope.editPageForm.$valid = false;
                     $scope.editPageForm.$invalid = true;
                     deffer.resolve();
                 });
             } else {
                 deffer.resolve();
             }
             return deffer.promise;
         }
         /**
          * [initStatus description] 初始化参数
          */
         function initStatus() {
             $scope.status = {
                 inputData: '',
                 imageArrs: [],
                 selectedImage: [],
             };
             $scope.list = {
                 id: 0,
                 articleTitle: "",
                 articleContent: "",
                 articleHtmlCon: "",
                 articleType: 3,
                 firstClassId: "",
                 secondClassId: "",
                 articleStatus: "",
                 remark: '',
                 opinion: '',
                 appendixFile: '',
             };
         }
         /**
          * [initList description] 初始化表单数据
          * @return {[type]} [description]
          */
         function initList() {
             var deffer = $q.defer();
             if (!!$stateParams.id) {
                 getDraftInfo().then(function (result) {
                     $scope.isRejection = result.data.articleStatus===1 && result.data.articleUseStatus===2; // 判断是否是退稿稿库稿件
                     for (var i in $scope.list) {
                         $scope.list[i] = result.data[i];
                     }
                     if (result.picUrlList.length) {
                         $scope.status.imageArrs = result.picUrlList.map(function(item) {
                             const imgUrlOrigin = new URL(item.url).origin;
                             return {
                                id: (new Date()).valueOf() + "" + Math.round(Math.random() * 10000),
                                fileName: item.fileName,
                                title: item.scrFile,
                                url: item.url.replace(imgUrlOrigin, ''),
                                imageUrl: item.url,
                                thumFileName: item.thumbFilePath,
                                instruction: item.picDesc,
                             }
                         });
                     }
                     deffer.resolve();
                 });
             } else {
                 deffer.resolve();
             }
             return deffer.promise;
         }
         /**
          * [getDraftInfo description] 查询稿件信息
          * @return {[type]} [description]
          */
         function getDraftInfo() {
             var deffer = $q.defer();
             var params = {
                 id: $stateParams.id
             };
             $scope.loadingPromise = httpService.http("/mcnww/web/article/findById.do", params, "get").then(function (result) {
                 deffer.resolve(result);
             });
             return deffer.promise;
         }
         /**
          * [initData description] 初始化数据
          * @return {[type]} [description]
          */
         function initData() {
             getClassicListOneLevel().then(function () {
                 return getClassicListTwoLevel();
             }).then(function () {
                 return initList();
             }).then(function (data) {
                 loadUeditor(data);
                 reSelectClassify();
             });
 
         }
         /**
          * [reSelectClassify description] 选中分类
          * @return {[type]} [description]
          */
         function reSelectClassify() {
             var flag = true;
             for (var i = 0; i < $scope.status.classicListOneLevel.length; i++) {
                 if ($scope.status.classicListOneLevel[i].id == $scope.list.firstClassId) {
                     flag = false;
                     $scope.status.selectedOneLevel = angular.copy($scope.status.classicListOneLevel[i]);
                     break;
                 }
             }
             if (flag) {
                 $scope.status.selectedOneLevel = angular.copy($scope.status.classicListOneLevel[0]);
             }
             flag = true;
             getClassicListTwoLevel().then(function () {
                 for (var j = 0; j < $scope.status.classicListTwoLevel.length; j++) {
                     if ($scope.status.classicListTwoLevel[j].id == $scope.list.secondClassId) {
                         flag = false;
                         $scope.status.selectedTwoLevel = angular.copy($scope.status.classicListTwoLevel[j]);
                         break;
                     }
                 }
                 if (flag) {
                     $scope.status.selectedTwoLevel = $scope.status.classicListTwoLeve === undefined ? $scope.status.selectedTwoLevel : $scope.status.classicListOneLevel.unshift({ name: "请选择" });
                     $scope.status.selectedTwoLevel = angular.copy($scope.status.classicListOneLevel[0]);
                 }
             });
         }
         /**
          * [getClassicList description] 获取一级分类
          * @return {[type]} [description]
          */
         function getClassicListOneLevel() {
             var deffer = $q.defer();
             httpService.http("/mcnww/web/classic/classicList.do", "", "get").then(function (data) {
                 $scope.status.classicListOneLevel = (function (data) {
                     for (var i in data.data) {
                         data.data[i].name = data.data[i].departName;
                     }
                     return data.data;
                 })(data);
                 $scope.status.classicListOneLevel.unshift({ name: "请选择" });
                 $scope.status.selectedOneLevel = $scope.status.classicListOneLevel[0];
                 // $scope.list.firstClassId = $scope.status.selectedOneLevel.id;
                 deffer.resolve();
             });
             return deffer.promise;
         }
         $scope.getClassicListTwoLevel = getClassicListTwoLevel;
         /**
          * [getClassicListTwoLevel description] 获取二级分类
          * @return {[type]} [description]
          */
         function getClassicListTwoLevel() {
             var deffer = $q.defer();
             if (!$scope.status.selectedOneLevel) {
                 deffer.resolve();
                 return deffer.promise;
             }
             var params = {
                 id: $scope.status.selectedOneLevel.id,
             };
             httpService.http("/mcnww/web/classic/classicList.do", params, "get").then(function (data) {
                 $scope.status.classicListTwoLevel = (function (data) {
                     for (var i in data.sList) {
                         data.sList[i].name = data.sList[i].departName;
                     }
                     return data.sList;
                 })(data);
                 $scope.status.classicListTwoLevel.unshift({ name: "请选择" });
                 $scope.status.selectedTwoLevel = angular.copy($scope.status.classicListTwoLevel[0]);
                 $scope.list.secondClassId = angular.isDefined($scope.list.secondClassId) ? $scope.list.secondClassId : undefined;
                 $scope.list.firstClassId = $scope.status.selectedOneLevel.id;
                 deffer.resolve();
             });
             return deffer.promise;
         }
 
         /**
          * [getTwoLevelid 获取二级分类id]
          * @return {[type]} [description]
          */
         $scope.getTwoLevelid = function () {
             $scope.list.secondClassId = $scope.status.selectedTwoLevel.id;
         };
         /**
          * [loadUeditor description] 加载编辑器
          * @return {[type]} [description]
          */
         function loadUeditor(data) {
             var $ueditor = $("<ueditor></ueditor>");
             var $ueditorLocation = $element.find("ueditorLocation");
             LazyLoad.js(["./static/ueditor/ueditor.config.js?v=11.4", "./static/ueditor/ueditor.all.js?v=11.4"], function () {
                 $ueditor.attr({
                     type: data,
                     list: "list",
                     "has-content": "status.hasContent",
                     versionid: $scope.list.id,
                     placeholder: "请输入文章正文",
                     infullscreen: "status.infullscreen",
                     doctype: "3"
                 });
                 $ueditor = $compile($ueditor)($scope);
                 $ueditorLocation.append($ueditor);
                 var ue = UE.getEditor('ueditor');
                 // ue.ready(function(){
                 //     ueditorService.drawVideoMark(true, true);
                 // });
             });
 
         }
         /**
          * [reFreshList description] 刷新列表页
          * @return {[type]} [description]
          */
         function reFreshListPage() {
             localStorageService.set("refresh", Math.random());
         }

         /**
         * [uploadPic description] 一次上传多张图片
         * @return {[type]} [description]
         */
        $scope.uploadPices = function($files) {
            if ($files) {
                if ($files.length == 0) return;
                let warnOnce=false;
                for (let i = $files.length - 1; i >= 0; i--) {
                    if ($files[i].size / 1024 / 1024 > 20) {
                        warnOnce=true;
                        $files.splice(i, 1);
                    }
                };
                if(warnOnce){
                    modalDialog.alertType("", "图片不能大于20M", "warning", "confirm");
                }
                var index;
                $files.forEach(function(file) {
                    $scope.loadingPromise = uploadPic(file).then(function(res) {
                        var obj = angular.copy(res);
                        obj.imageUrl = angular.globalConfig.pictureServer + res.url;
                        obj.instruction = res.original || "";
                        //给图片加上一个唯一的id 便于后面的修改和编辑
                        obj.id = (new Date()).valueOf() + "" + Math.round(Math.random() * 10000);
                        $scope.status.imageArrs.push(obj);
                        if (!index) {
                            index = $scope.status.imageArrs.length;
                            $timeout(function() {
                                var html = $("html");
                                var tr = $("table tbody tr")[index - 1];
                                html.animate({ scrollTop: html.scrollTop() + $(tr).offset().top - html.offset().top }, 500);
                            })
                        }
                    }).catch(function(error) {
                        modalDialog.alertType("", error.message, "error", false);
                    })
                })
            }
        };
        /**
         * [uploadPic description] 上传图片的公共方法
         * @return {[type]} [description]
         */
        function uploadPic(file) {
            var defer = $q.defer();
            if (file.size > Number($scope.status.picSizeLimit) * 1024) {
                modalDialog.alertType("", "图片最大不能超过" + $scope.status.picSizeLimit + "KB!", "warning", "confirm");
                return;
            }
            var fd = new FormData();
            var name = file.name;
            fd.append("file", file);
            fd.append("name", name);
            $scope.loadingPromise = $.ajax({
                url: '/mcnww/upload/image.do',
                type: 'POST',
                headers:{requestToken:sessionStorage.getItem('requestToken')},
                async: false,
                data: fd,
                processData: false,
                contentType: false,
                success: function(data) {
                    if (data.success) {
                        defer.resolve(data);
                    } else {
                        defer.reject(data);
                    }
                }
            });
            return defer.promise;
        }

         /**
         * [moveUploadImg description]图集上传图片列表拖拽
         * @param  {[type]} index [description]
         * @return {[type]}       [description]
         */
        $scope.moveUploadImg = function(index) {
            $scope.status.imageArrs.splice(index, 1);

        };
        /**
         * [selectImage description] 选中图片项的集合
         * @return {[type]} [description]
         */
        $scope.selectImage = function(item) {
            if ($scope.status.selectedImage.indexOf(item.id) > -1) {
                $scope.status.selectedImage.splice($scope.status.selectedImage.indexOf(item.id), 1);
            } else {
                $scope.status.selectedImage.push(item.id);
            }
        };
        /**
         * [replaceIamge description] 更换图片
         * @return {[type]} [description]
         */
        $scope.repalceImage = function($files, item) {
            if ($files && $files.length == 0) return;
            uploadPic($files[0]).then(function(res) {
                $scope.status.imageArrs = $scope.status.imageArrs.map(function(val) {
                    if (val.id === item.id) {
                        val.imageUrl = res.url;
                        val.instruction = item.instruction;
                        //给图片加上一个唯一的id 便于后面的修改和编辑
                        val.id = (new Date()).valueOf() + "" + Math.round(Math.random() * 10000);
                    }
                    return val;
                })
            }).catch(function(error) {
                modalDialog.alertType("", error.message, "error", false);
            })
        }
        /**
         * [editImage description] 编辑图片
         * @return {[type]} [description]
         */
        $scope.editImage = function(item) {
            editPictureService.newCropperAppForImage(angular.globalConfig.pictureServer + item.imageUrl, "").then(function(data) {
                $scope.status.imageArrs = $scope.status.imageArrs.map(function(val) {
                    if (val.id === item.id) {
                        val.imageUrl = data.imgSrc;
                        val.instruction = item.instruction;
                        //给图片加上一个唯一的id 便于后面的修改和编辑
                        val.id = (new Date()).valueOf() + "" + Math.round(Math.random() * 10000);
                    }
                    return val;
                })
            });
        }
        /**
         * [syncInstruction description] 同步所有说明
         * @return {[type]} [description]
         */
        $scope.syncInstruction = function(item) {
            modalDialog.confirmModal("同步", "确定同步所有说明吗？", function() {
                if (item.instruction == "") {
                    return;
                }
                $scope.status.imageArrs = $scope.status.imageArrs.map(function(val) {
                    val.instruction = item.instruction;
                    return val;
                })
            });
        }

        $scope.moveImgUp = function(index) {
            changeArrIndex($scope.status.imageArrs, index, index-1)
        };

        $scope.moveImgDown = function(index) {
            changeArrIndex($scope.status.imageArrs, index, index+1)
        };

        function changeArrIndex(arr,startIndex,endIndex) {
            arr[startIndex] = arr.splice(endIndex,1,arr[startIndex])[0]
            return arr;
        }

        $scope.deleteImage = function(index) {
            $scope.status.imageArrs.splice(index,1);
        };

        /**
         * [deleteByQuery description] 批量删除
         * @return {[type]} [description]
         */
        $scope.deleteByQuery = function() {
            modalDialog.confirmModal("删除", "确定删除选中的图片吗？", function() {
                $scope.status.selectedImage.forEach(function(id) {
                    $scope.status.imageArrs = $scope.status.imageArrs.filter(function(val) {
                        return val.id !== id
                    })
                })
                $scope.status.selectedImage = []; //清空选项
            });
        }


     }]);